<app-modal (close)="hide()" [isOpen]="modalOpen" id="loaderModal">
    <fa-icon icon="circle-notch" [spin]="true" size="4x"></fa-icon>
</app-modal>
